<template>
	<div class="page">

		<!-- page header -->
		<div class="page-header" :class="this.showPageHeader ? 'scroll show' : 'scroll hide'">

			<div style=""
				:class="this.isAnyPageMenuVisible() ? 'page-header-menu page-header-menu-show' : 'page-header-menu page-header-menu-hide'">
				<div class="center  center-padding page-header-menu" @click.self="this.hidePopovers()" style="">

					<!-- innehåll page meny top -->
					<div class="flexcenter" style="width:100%;align-items: baseline;gap:10px;" @click.self="this.hidePopovers()">


						<div class="flexcenter link mobil" style="padding:5px;padding-left:0px;border-radius:5px;"
							@click="this.showSideMenuCategory()">
							<b>Kategorier </b>
							<Icon fileName="w3_chevron_right_dark" style="height:10px;width:7px;margin-left:1px;" />
						</div>

						<div class="flexcenter link desktop" style="padding:5px;border-radius:5px;padding-left:0px;"
							@click="this.togglePageMenu('menuCategory')">
							<b>Kategorier</b>
						</div>

						<div class="flexcenter link" style="padding:5px;border-radius:5px;"
							@click="this.togglePageMenu('menuManufactor')">
							<b>Varumärken</b>
						</div>

						<div class="flexcenter link" style="padding:5px;border-radius:5px;" @click="this.togglePageMenu('menuMV')">
							<b>Modellväljaren</b>
						</div>


						<div v-if="this.debug" class="flexcenter link"
							style="background:var(--grey-4);padding:5px;border-radius:5px;" @click="getProductRowList()">
							<b>Hämta</b>
							<Icon v-if="this.productSpinner" fileName="w3_spinner_dark" class="spinner"
								style="width:20px;height:20px;margin-left:5px;" />
						</div>

						<div v-if="this.debug" class="flexcenter link"
							style="background:var(--grey-4);padding:5px;border-radius:5px;" @click="triggerSearch()">
							<b>SÖK</b>
							<Icon fileName="button_down_dark" style="width:20px;height:20px;margin-left:5px;" />

						</div>

						<div v-if="this.debug">
							<input type="checkbox" v-model="autoSearch" title="Autosök (tryck enter för att söka annars)" />Autosök
							<Button label="url" @click="this.setupUrl()" />
						</div>

						<div style=" flex-grow:1;background:transparent;height:20px;" @click="this.hideAllPageMenu()">&nbsp;
						</div>
						<div v-if="this.debug" @click="this.togglePageMenu('menuSearch')" class="link flexcenter">
							<b>Visa menu A </b>
							<Icon fileName="button_down_dark" style="width:20px;height:20px;margin-left:5px;" />
						</div>



					</div>

					<!-- KOPIERAD sökfältet --
					<div v-if="!this">
						<div class="form textField" :title="'filter: ' + this.tableConfig.filter" style="margin-top:10px;">
							<input type="text" placeholder="Sök efter produkter, tillverkare, mc-modeller." v-model="filterInput"
								@click="this.showPageMenu('menuSearch');" @keypress.enter="enterPressed" />

							<Icon v-if="this.spinning" fileName="w3_spinner_dark" class="spinner" style="margin-right:5px;" />
							<img src="@/assets/w3_button_close_light.png" @click="this.filterInput = '';this.enterPressed();"
								style="margin-right:5px;" />
							<Button label="Sök" @click="this.enterPressed()" />

						</div>
						<div v-if="!this" class="center drop-shadow"
							style="position:absolute;height:40px;width:100%;background:var(--grey-4);z-index:40;border-radius: 0px 0px 5px 5px;">
							<div class="flexcenter" style="padding:10px;">
								<div v-for="(sort) in this.sortList" :key="sort.name"
									style="background:var(--grey-6);padding:2px;font-size: 80%;font-weight: bold;color:white;border-radius: 5px;margin-right:2px;padding-left:5px;padding-right:5px;">
									{{ sort.name }}
								</div>
							</div>
						</div>
					</div -->

					<SearchProductTextfield v-if="this" @click="this.productSearchEnabled && (this.showPageMenu('menuSearch'));"
						@enterPressed="this.enterPressed()" @closeProductSearchPopover="(() => this.hideAllPageMenu())"
						v-model:filterInput="this.filterInput" :spinning="this.searchProductTextfieldSpinning"
						@showProductSearchPopover="this.showProductSerachPopover()" />

					<!-- @filterInputChanged="((filterInput) => this.filterInput = filterInput) -->

					<!-- wrapper till boxar (mc, kategori) och filter (alla produkter)-->
					<div id="filter-wrapper" class="flexcenter" style="align-items: start;">

						<!-- sök-filter (boxar med dropdowns) -->
						<div style="align-items:start;padding-top:5px;" class="filter-boxes flexcenter"
							@click.self="this.hidePopovers()">

							<!-- MC -->
							<SelectMc v-if="this.showSelectMc" ref="popoverMc" :baseMcList="baseMcList" :baseMcTree="baseMcTree"
								:brand="this.searchProductConfig.brand" :mc="this.searchProductConfig.mc"
								:year="this.searchProductConfig.year" @brandSelected="(brand) => this.searchProductConfig.brand = brand"
								@mcSelected="(mc) => this.searchProductConfig.mc = mc"
								@yearSelected="(year) => this.searchProductConfig.year = year" style="z-index:35;"
								@selectPopoverOpen="selectPopoverOpen" />

							<SelectCategory ref="popoverCategory" :categoryModel="this.baseCategoryModel"
								:category="this.searchProductConfig.category"
								@categorySelected="(category) => this.searchProductConfig.category = category" style="z-index:34;"
								@selectPopoverOpen="selectPopoverOpen" />



							<SelectManufactor ref="popoverManufactor" :baseManufactorList="this.baseManufactorList"
								:manufactor="this.searchProductConfig.manufactor"
								@manufactorSelected="(manufactor) => this.searchProductConfig.manufactor = manufactor"
								style="z-index:33;" :baseManufactorListAllLength="this.baseManufactorListAllLength"
								@selectPopoverOpen="selectPopoverOpen" />

							<b style="flex-grow:1;">&nbsp;</b>

							<!-- sökresultat, liten badge med Visar xx av yy -->
							<div v-if="!this && this.isPageMenuVisible('menuSearch')" class="flexcenter"
								style="background:var(--grey-3);padding:5px;border-radius: 5px;">
								Visar {{ this.tableConfig.scrollLimit }} av {{ this.model.totalCount }}
							</div>

							<div v-if="debug">
								<!-- debug-info om sökresultatet  -->
								<Button label="Sökdata" showDebugResultshowDebugResult
									@click="this.showDebugResult = !this.showDebugResult" />

								<div class="drop-shadow" v-if="this.showDebugResult"
									style="width:300px;margin-left:-265px;position:absolute;background-color: var(--grey-3);padding:10px;max-height:500px;overflow:scroll;z-index:30;margin-top:50px;">
									scrollLimit (visar): {{ this.tableConfig.scrollLimit }} resultCount: {{ this.model.resultCount }}
									totalCount: {{
									this.model.totalCount }} <br />
									origin: {{ this.searchModel.meta.origin }}
									<hr />
									searchProductResult.productList.length: {{ this.searchProductResult.productList.length }},
									searchModel.productList.length: {{ this.searchModel.productList.length }}, <br />
									searchProductConfig.manufactorId: {{ this.searchProductConfig.manufactorId }}
									searchModel.manufactorIdInResult: {{ this.searchModel.manufactorIdInResult }}
									<hr />
									popoverOpen: {{ this.searchProductConfig.popoverOpen }}
									<hr />

									CategoryProductLength: {{ this.searchProductConfig.category &&
									this.searchProductConfig.category.productList ? this.searchProductConfig.category.productList.length :
									0
									}}

									<hr />

									brand: {{ this.searchProductConfig.brand ? this.searchProductConfig?.brand?.name : '--' }} <br />
									mc: {{ this.searchProductConfig.mc ? this.searchProductConfig.mc.modelName : '--' }} <br />
									year: {{ this.searchProductConfig.year ? this.searchProductConfig.year : '--' }} <br />
									<hr />


								</div>


							</div>
						</div>


						<!-- produktgrupper och sortering och filter-->
						<div id="dropdownGroupWrapper" style="margin-top:5px;flex-grow:1;">

							<div v-if="!this.isPageMenuVisible('menuSearch')" id="dropdownGroup" class="flexcenter"
								style="align-items: stretch;">

								<!--SelectCategoryBR :categoryModel="this.baseCategoryModel" :category="this.searchProductConfig.category"
								@categorySelected="(category) => this.searchProductConfig.category = category" style="z-index:5;" / -->

								<!-- produkt filter endast i lager -->
								<div v-if="!this" class="mobile">
									<div id="filter-button-mobile" class="flexcenter" style="" @click="this.filterPressed()">
										<Circle size="25px" color="--grey-3" fileName="" />
										<b class="font-small" style="color:#aaa;">Filter</b>
									</div>
								</div>

								<div id="filter-button-desktop">
									<div class="flexcenter link" style="" @click="this.filterPopover = !this.filterPopover">

										<!-- icon till filter -->
										<Circle v-if="!this.searchProductConfig?.filter?.onlyInStock" size="25px" color="--grey-5"
											fileName="w3_filter_white" padding="15%" />

										<Icon v-if="this.searchProductConfig?.filter?.onlyInStock" fileName="w3_circle_in_stock_green"
											color="--bg-ok-solid" style="width:25px;height:25px;"
											title="Visar endast produkter som finns i lager" />



										<b class="font-small" style="margin-left:5px;">Filter</b>

										<!-- pills till filter -->
										<div class="desktop flexcenter" id="filterList"
											style="flex-direction:row;overflow:scroll;padding-left:5px;flex-grow:1;">

											<div v-if="this.searchProductConfig?.filter?.onlyInStock"
												class="flexcenter filter font-smallest link" @click.stop="this.toggleOnlyInStock()"
												title="Ta bort filter: Visar endast i lager. ">
												<b>I lager</b>
												<Icon fileName="w3_circle_close_white" style="width:15px;height:15px;margin-left:3px;" />
											</div>

										</div>

										<Icon :fileName="this.filterPopover ? 'w3_chevron_up_dark' : 'w3_chevron_down_dark'"
											style="width:12px;height:12px;margin-left:5px;margin-right:5px;" />
									</div>

									<!-- filter dropdown -->
									<div v-if="this.filterPopover" class="dropdown dropdown-w200 dropdown-shadow"
										style="height:auto;background:var(--grey-3);max-height: 300px;overflow:scroll;padding:5px;"
										@mouseleave="this.filterPopover = false">

										<div style="padding:0px;">

											<div class="flexcenter link"
												style="padding:5px;margin-bottom:5px;border-radius: 5px;background:var(--grey-1);"
												@click="(() => {this.toggleOnlyInStock(); this.filterPopover = false })">
												<Circle
													:fileName="this.searchProductConfig?.filter?.onlyInStock ? 'w3_circle_in_stock_green' : 'w3_circle_in_stock_grey'"
													color="" hover="" size="25px" padding="10%" style="margin-right:5px;" />
												Endast i lager
											</div>

										</div>


									</div>
								</div>



								<!-- produktGrupper productGroupKeyList -->
								<div id="dropdown-product-key">

									<!-- selected productGroup-->
									<div id="dropdown-product-key-button" class="flexcenter link" style=""
										@click="this.productGroupPopover = !this.productGroupPopover">

										<!-- label produktgrupp -->
										<div style="position:relative;display: inline-block;"
											:class="this.searchProductConfig?.filter?.onlyInStock ? 'link' : '' ">


											<Circle v-if="this.productGroup.key != null" size="25px"
												:fileName="'w3_' + this.productGroupIconLabel(this.productGroup)?.fileName "
												color="--bg-message"
												:padding="this.productGroupIconLabel(this.productGroup)?.padding ? this.productGroupIconLabel(this.productGroup)?.padding : '20%'"
												hover=""
												:title="this.searchProductConfig?.filter?.onlyInStock ? 'Visar endast produkter som finns i lager' : ''" />

											<!-- label produktgrupp och endast i lager  (visar den lilla i lager badgen) -->
											<Icon
												v-if="!this && this.productGroup.key != null && this.searchProductConfig?.filter?.onlyInStock"
												fileName="w3_circle_in_stock_green" title="Visar endast produkter som finns i lager"
												style="height:17px;width:17px;position:absolute;top:-4px;left:-4px;"
												@click.stop="this.searchProductConfig.filter.onlyInStock ? this.searchProductConfig.filter.onlyInStock = false : null" />
										</div>



										<!-- label alla produkter och endast i lager (visar grön bakgrund om den är i lager) -->
										<Icon v-if="!this && this.productGroup.key == null && this.searchProductConfig?.filter?.onlyInStock"
											fileName="w3_circle_in_stock_green" color="--bg-ok-solid" style="width:25px;height:25px;"
											title="Visar endast produkter som finns i lager" />


										<!-- label alla produkter oavsett lager -->
										<div v-if="this.productGroup.key == null" style="width:0px;height:25px;">&nbsp;</div>

										<div class="flexcenter"
											style="flex-direction: column;padding-left:5px;flex-grow:1;align-items: start;gap:0px;">


											<b class="desktop" :class="this.onlyInStock ? 'font-smallest' : 'font-small' "
												:style="productGroup.outlet ? 'color:var(--font-color-outlet);' : ''"> {{
												this.productGroupLabel(this.productGroup)
												}}
											</b>

											<b style="" class="mobile font-small"
												:style="productGroup.outlet ? 'color:var(--font-color-outlet);' : ''">{{
												this.productGroupLabelMobile(this.productGroup)
												}}
											</b>

											<b v-if="this.onlyInStock" style="font-size:0.6rem;">Endast i lager</b>

										</div>


										<Icon :fileName="this.productGroupPopover ? 'w3_chevron_up_dark' : 'w3_chevron_down_dark' "
											style="width:12px;height:12px;margin-right:5px;" />
									</div>

									<!-- listan med productGroups Alla produkter productGroupList -->
									<div v-if="this.productGroupPopover" class="dropdown dropdown-w200 dropdown-shadow"
										style="height:auto;background:var(--grey-3);max-height: 300px;overflow:scroll;padding:5px;"
										@mouseleave="this.productGroupPopover = false">

										<div v-for="(productGroup) in this.productGroupKeyList" :key="productGroup.key"
											style="padding:5px;margin-bottom:5px;border-radius: 5px;"
											@click="this.productGroupChanged(productGroup)" class="link flexcenter"
											:style="this.isProductGroupSelected(productGroup) ? 'background:var(--grey-4);' : 'background:var(--grey-1);'">

											<Circle size="25px" :fileName="'w3_' + this.productGroupIconDropdown(productGroup)?.fileName"
												color=""
												:padding="this.productGroupIconDropdown(productGroup)?.padding ? this.productGroupIconDropdown(productGroup)?.padding : '15%'"
												hover="" style="margin-right:5px;" />

											<div style="flex-grow:1;" class="font-small">{{
												productGroup.label }} </div>

											<div v-if="productGroup?.productIdList?.length > 0" class="badge" style="font-size:80%;">{{
												productGroup?.productIdList?.length }}</div>

											<!--Circle size="20px" fileName="" color="--grey-3" /-->
										</div>
										<div v-if="!this" style="padding:0px;">

											<div class="flexcenter link"
												style="padding:5px;margin-bottom:5px;border-radius: 5px;background:var(--grey-1);"
												@click="(() => this.toggleOnlyInStock())">
												<Circle
													:fileName="this.searchProductConfig?.filter?.onlyInStock ? 'w3_circle_in_stock_green' : 'w3_circle_in_stock_grey' "
													color="" hover="" size="25px" padding="10%" style="margin-right:5px;" />
												Endast i lager
											</div>

										</div>

									</div>

								</div>


								<!-- sortering -->
								<div id="dropdown-sort">
									<div id="dropdown-sort-button" class="flexcenter link" style=""
										@click="this.sortPopover = !this.sortPopover">

										<Circle size="25px"
											:fileName="this.searchProductConfig?.sort?.desc ? 'w3_sort_bars_desc_white' : 'w3_sort_bars_asc_white'"
											color="--bg-light" hover="" padding="20%" />

										<b style="flex-grow:1;padding-left:5px;" class="desktop font-small">{{
											this.searchProductConfig?.sort?.name }}</b>
										<b style="flex-grow:1;padding-left:2px;" class="mobile font-small">{{
											this.searchProductConfig?.sort?.short }}</b>
										<Icon fileName="w3_chevron_down_dark"
											style="width:12px;height:12px;margin-right:5px;margin-left:5px;" />
									</div>

									<!-- dropdown -->
									<div v-if="this.sortPopover" class="dropdown dropdown-shadow dropdown-w200"
										style="height:auto;background:var(--grey-3);max-height: 300px;overflow:scroll;padding:5px;"
										@mouseleave="this.sortPopover = false">

										<div v-for="(sort) in this.sortList" :key="sort.key"
											style="padding:5px;margin-bottom:5px;border-radius: 5px;"
											@click="this.searchProductConfig.sort = sort; this.sortPopover = false;this.resetScrollLimit()"
											class="link flexcenter"
											:style="this.isSortSelected(sort) ? 'background:var(--grey-5);' : 'background:var(--grey-1);'">
											<div style="flex-grow:1;" class="font-small">{{
												sort.name }}</div>

											<Circle size="20px" fileName="" color="--grey-3" />
										</div>

									</div>

								</div>





								<Icon v-if="this.debug"
									:fileName="this.searchProductConfig.layout == 'LIST' ? 'w3_circle_list_image_dark' : 'w3_circle_list_image_light'"
									@click="this.searchProductConfig.layout = 'LIST'" style="height:25px;width:25px;" />

								<Icon v-if="this.debug"
									:fileName="this.searchProductConfig.layout == 'GRID' ? 'w3_circle_grid_dark' : 'w3_circle_grid_light'"
									@click="this.searchProductConfig.layout = 'GRID'" style="height:25px;width:25px;" />


							</div>
							<div v-if="this.isPageMenuVisible('menuSearch')" class="flexcenter"
								style="align-items:center;justify-content: end;margin-top:5px;">

								<b style="color:grey;" class="font-small link" @click="this.hideAllPageMenu()">Stäng sökning</b>
								<Icon fileName="w3_chevron_up_dark" style="margin-left:5px;width:15px;height:15px;" />
							</div>



						</div>

					</div>
				</div>

			</div>

			<SearchPopoverView v-if="this" class="page-menu" :class="this.isPageMenuVisible('menuSearch') ? 'show' : 'hide'"
				:model="this.model" @click.self="this.hideAllPageMenu()"
				@showProductDetails="((product) => { this.showProductDetails(product); this.searchProductConfig.popoverOpen = true; })"
				@hideAllPageMenu="(() => this.hideAllPageMenu())" @closePopoverPressed="(() => this.hideAllPageMenu())"
				@searchManufactorSelected="((manufactor) => { this.searchManufactorSelectedWithoutNavigation(manufactor); this.hideAllPageMenu() })"
				@searchCategorySelected="((category) => { this.searchCategorySelectedWithoutNavigation(category); this.hideAllPageMenu() })"
				@searchMcSelected="((mc) => { this.searchMcSelectedWithoutNavigation(mc); this.hideAllPageMenu() })"
				@enterPressed="(() => this.enterPressed())" @resetScrollLimit="(() => this.resetScrollLimit())" />


			<!-- KOPIERAD HIT -->
			<!-- page menu done-->

			<!-- page menu open menu  modellväljaren -->
			<div class="page-menu page-menu-menu-mv" :class="this.isPageMenuVisible('menuMV') ? 'show' : 'hide'"
				@click.self="this.hideAllPageMenu()">

				<div v-if="!this" class="center-padding center" style="min-height:350px; ">
					<!-- FP: rensa bort detta -->

					<!-- innehåll -->
					<h3>Modellväljaren</h3><br />
					<div style="padding:0px;align-items: start;" class="flexcenter" title="Välj mc-märke och mc-modell">



						<select v-if="this.baseMcTree" v-model="this.searchProductConfig.brand" size="10" style="width:200px;">

							<option v-for="(brand) in this.baseMcTree" :key="brand.id" :value="brand">{{ brand.name }}
							</option>
						</select>

						<select v-if="this.baseMcTree" v-model="this.searchProductConfig.mc" size="10" style="width:300px;">

							<option v-for="mc in this.searchProductConfig.brand && this.searchProductConfig.brand.modelList"
								:key="mc.mcId" :value="mc">{{ mc.modelName }}
							</option>

						</select>

						<select v-if="this.baseMcTree" v-model="this.searchProductConfig.year" @change="yearSelectedMV();" size="10"
							style="width:100px;">

							<option
								v-for="year in this.searchProductConfig.mc && this.searchProductConfig.mc.yearList?.filter(year => year !== null).sort((a, b) => b.year - a.year)"
								:key="year.year" :value="year">{{
								year.year }}
							</option>

						</select>

					</div>


					<div>


						<Button label="OK" style="margin-top:10px;" @click="() => { this.hideAllPageMenu() }" />
					</div>
				</div>

				<div v-if="this" class="center-padding center" style="min-height:350px; ">
					<PopoverModelPicker :show="this.isPageMenuVisible('menuMV')"
						@modelPickerComplete="(() => this.hideAllPageMenu())" @modelPickerCancel="(() => this.hideAllPageMenu())" />
				</div>

			</div>

			<!-- menu kategorier - popover med grid med kategorier (ej klar) -->
			<div class="page-menu page-menu-menu-category" :class="this.isPageMenuVisible('menuCategory') ? 'show' : 'hide'"
				@click.self="this.hideAllPageMenu()">

				<div class="center-padding center" style="min-height:350px; ">

					<PopoverCategoryView
						@searchCategorySelected="((category) => { this.resetSearchProductConfig(); this.searchCategorySelected(category) })"
						@popoverCategoryClosed="(() => this.hideAllPageMenu())" />
				</div>
			</div>

			<!-- menu manufactor - popover med grid med varumärken #MENUM -->
			<div class="page-menu page-menu-menu-manufactor"
				:class="this.isPageMenuVisible('menuManufactor') ? 'show' : 'hide'" @click.self="this.hideAllPageMenu()">

				<div v-if="!this" class="center-padding center" style="min-height:350px; ">

					<!-- innehåll -  -->
					<div class="flexcenter" style="align-items: stretch;justify-content: space-around; flex-wrap:wrap;gap:5px;">

						<div v-for="(manufactor, index) in this.baseManufactorListAll" :key="manufactor.manufactorId + '_' + index"
							class="link" style="background:var(--grey-3);padding:10px;border-radius:5px;"
							@click="searchManufactorSelected(manufactor)">

							{{ manufactor.name }}
						</div>

					</div>


					<div>
						<Button label="OK" style="margin-top:10px;" @click="() => { this.hideAllPageMenu() }" />
					</div>
				</div>

				<div v-if="this" class="center-padding center" style="min-height:350px;  ">
					<PopoverManufactorView
						@searchManufactorSelected="((manufactor) => { this.resetSearchProductConfig(); this.searchManufactorSelected(manufactor) })"
						@popoverManufactorClosed="(() => this.hideAllPageMenu())" :productTypeFilter="false" />
				</div>

			</div>
			<!-- page menu done-->

		</div>


		<!-- page-blur -->
		<div class="page-blur" :class="this.isAnyPageMenuVisible() ? 'blur-on' : 'blur-off'"
			@mouseenter="this.hideAllPageMenu()" @click="this.hideAllPageMenu()">
		</div>

		<!-- content -->
		<div :class="this.isAnyPageMenuVisible() ? 'menu-visible' : ''">

			<!-- filter sortering, grid / list -->
			<div v-if="!this" style="background: var(--grey-3);" class="padding-auto ">


				<div class="center center-padding flexcenter" style="align-items:stretch;">

					<!--SelectCategoryBR :categoryModel="this.baseCategoryModel" :category="this.searchProductConfig.category"
						@categorySelected="(category) => this.searchProductConfig.category = category" style="z-index:5;" /-->


					<b style="flex-grow:1">&nbsp;</b>
					<select v-model="this.searchProductConfig.sort">

						<option v-for="(sort) in this.sortList" :key="sort.key" :value="sort"> {{ sort.name }}</option>
					</select>

					<Icon
						:fileName="this.searchProductConfig.layout == 'LIST' ? 'w3_circle_list_image_dark' : 'w3_circle_list_image_light'"
						@click="this.searchProductConfig.layout = 'LIST'" />

					<Icon :fileName="this.searchProductConfig.layout == 'GRID' ? 'w3_circle_grid_dark' : 'w3_circle_grid_light'"
						@click="this.searchProductConfig.layout = 'GRID'" />


				</div>



			</div>

			<div style="background:var(--white); "> <!-- FP: här kan man sätta bakgrunden på produktlistan -->


				<div class="center center-padding">



					<!-- innehåll  -->
					<div class="">




						<!-- SM searchResult  visas överst i söklistan (under popover)-->
						<div v-if="!this" id="resultList" style="width:100%;" class="margin-top-auto">

							<div v-if="this.searchProductResult && this.searchProductResult.productList"
								style="background:var(--grey-2);margin-top:5px;margin-bottom:5px;padding:5px;min-height:50px;max-height:300px;overflow:scroll;border-radius: 5px;">

								<!-- sökresultat header -->
								<div v-if="this.searchProductResult && this.searchProductResult.meta"
									style="background:var(--grey-6);margin-bottom:10px;padding:10px;color:white;border-radius: 5px;">
									{{ this.searchProductResult.meta }} Antal: {{ this.searchProductResult &&
									this.searchProductResult.productList
									? this.searchProductResult.productList.length : '' }}
								</div>


							</div>
						</div>

						<div v-if="this.showLoadingProducts" class="flexcenter drop-shadow-light"
							style="position:absolute;z-index:10;padding:10px;background-color:var(--grey-1);border-radius: 5px;">

							<Icon fileName="w3_spinner_grey" class="spinner"
								style="margin-right:5px;margin-left:5px;width:20px;height:20px;" />
							<b class="font-smaller" style="color:grey;margin-left:5px;margin-right:5px;">Hämtar produkter</b>
						</div>


						<div v-if="this.showRebuildSearchIndex" class="flexcenter drop-shadow-light"
							style="position:fixed;z-index:10;padding:10px;background-color:var(--grey-1);border-radius: 5px;">

							<Icon fileName="w3_spinner_grey" class="spinner"
								style="margin-right:5px;margin-left:5px;width:20px;height:20px;" />
							<b class="font-smaller" style="color:grey;margin-left:5px;margin-right:5px;">Skapar produktlista</b>
						</div>

						<!-- produktlista - resultat -->
						<div v-if="!this.showRebuildSearchIndex" id="resultList" style="width:100%;" class="padding-top-auto">


							<div v-if="this.productGroup?.outlet && this.searchProductConfig.layout == 'GRID'" style="">

								<!-- grid grupperad efter tillverkare -->
								<div id="manufactorGrid" class="flexcenter" style="overflow-y:scroll;height:30px;">
									<div v-for="(manufactor) in this.groupedProductListModel?.manufactorList"
										:key="manufactor.manufactorId" class="flexcenter link" style=""
										@click="this.scrollToManufactorId(manufactor?.manufactorId)">
										<b>{{ manufactor?.name }}</b>
									</div>
								</div>

								<div v-for="(manufactor) in this.groupedProductListModel?.manufactorList" :key="manufactor.manufactorId"
									style="margin-bottom:10px;">
									<div :ref="((el) => manufactorRefs[manufactor.manufactorId] = el)" style="scroll-margin-top: 200px;">
										<h3>{{ manufactor?.name }}</h3>
									</div>
									<div class="productGrid">
										<ProductCell class="product"
											v-for="(product, index) in this.groupedProductListModel?.groupedProductMap?.get(manufactor?.manufactorId)"
											:key="index + '-' + product.productId" :rowIndex="index" :productId="product?.productId"
											:parentTitle="this.title" :favorite="this.isFavorite(product?.productId)"
											:outlet="this.isOutlet(product?.productId)" :canFavorite="true"
											@showProductDetails="((product) => this.showProductDetails(product))" />
									</div>



								</div>

							</div>

							<!-- vanlig product grid -->
							<div v-if="!this.productGroup?.outlet && this.searchProductConfig.layout == 'GRID'" class="productGrid">

								<ProductCell class="product" v-for="(product, index) in this.modelProductList"
									:key="index + '-' + product.productId" :rowIndex="index" :productId="product?.productId"
									:parentTitle="this.title" :favorite="this.isFavorite(product?.productId)"
									:outlet="this.isOutlet(product?.productId)" :canFavorite="true"
									@showProductDetails="((product) => this.showProductDetails(product))" />

							</div>

							<div v-if="this.searchProductConfig.layout == 'LIST'" class="layout-list">
								<table class="dataTable">
									<thead>
										<tr>
											<th>
												<div>ROW</div>
											</th>
											<th>
												<div>PID</div>
											</th>
											<th>
												<div>Artnr</div>
											</th>
											<th>
												<div>Benämning</div>
											</th>
											<th>
												<div>Tillverkare</div>
											</th>
											<th>
												<div>Score</div>
											</th>
											<th>
												<div>Price2</div>
											</th>
											<th>
												<div>BILD</div>
											</th>
											<th>
												<div>StartImage</div>
											</th>
											<th>
												<div>Items</div>
											</th>
											<th>
												<div>
													Detaljer
												</div>
											</th>
										</tr>
									</thead>
									<!--div v-for="(entity, index) in this.productListSorted" :key="index">{{entity }}</div -->

									<ProductRow class="product" v-for="(product, index) in this.model.productList" :key="index"
										:rowIndex="index" :productId="product.productId" :class="{ odd: index % 2 === 0 }" />

								</table>
							</div>


						</div>

						<div v-if="this.productGroup?.key != null || this.searchProductConfig?.filter?.onlyInStock"
							style="margin-top:20px;justify-content: center;" class=" font-small">
							<div id="product-group-type-footer" class="flexcenter" style="">
								<div>


									Du visar bara produkter <b style="color:green;">{{ this.searchProductConfig?.filter?.onlyInStock ?
										'som finns i lager' : ''
										}}</b> ur gruppen: <b>{{ this.productGroup.label }}</b>, som är ett urval av våra
									produkter.
								</div>
								<div id="product-group-type-footer-button"
									style="margin-left:5px;background:var(--grey-3);border-radius:5px;" @click="this.showAllProductList()"
									class="link flexcenter">
									<b>Visa alla produkterna</b>
									<Icon fileName="w3_chevron_right_light" style="width:10px;height:15px;margin-left:5px;" />
								</div>
							</div>



						</div>



						<div style="height:50px;">

						</div>

					</div>

				</div>
			</div>

		</div>




	</div>
</template>

<script>
import { logMixin } from "@/mixins/logMixin.js";
import { pageMixin } from "@/mixins/pageMixin.js";
import { productMixin } from "@/mixins/productMixin.js";

import { tableConfigMixin } from "@/mixins/tableConfigMixin.js";

import { STORE_COMMIT, STORE_GETTER, STORE_SORT } from "../../store/store";


import { PRODUCT_STORE_ACTION, PRODUCT_STORE_GETTER } from "../../store/product-store";

import ProductRow from "@/views/product/ProductRow.vue";



import SelectManufactor from '@/components/product/search/SelectManufactor.vue';
import SelectCategory from "@/components/product/search/SelectCategory.vue";
//import SelectCategoryBR from "@/components/product/search/SelectCategoryBR.vue";
import SelectMc from "@/components/product/search/SelectMc.vue";

import { modelMixin } from "../../mixins/modelMixin";
import { productSearchMixin } from "../../mixins/productSearchMixin";
import { routerMixin } from "../../mixins/routerMixin";

//import SearchResultProductRow from "./SearchResultProductRow.vue";

import ProductCell from "./ProductCell.vue";
import SearchPopoverView from "./SearchPopoverView.vue";
import SearchProductTextfield from "./SearchProductTextfield.vue";
import PopoverManufactorView from "./PopoverManufactorView.vue";
import PopoverCategoryView from "./PopoverCategoryView.vue";
import PopoverModelPicker from "./PopoverModelPicker.vue";
import categoryHelper from "../../helper/category-helper";
import settings from "../../settings";


export default {
	name: "Products",
	components: {
		ProductRow, SelectManufactor, SelectCategory, SelectMc,
		ProductCell, SearchPopoverView, SearchProductTextfield, PopoverManufactorView, PopoverCategoryView,
		PopoverModelPicker
	},
	mixins: [logMixin, pageMixin, tableConfigMixin, productMixin, modelMixin, productSearchMixin, routerMixin],
	props: {
		productTypeKey: String
	},
	data() {
		return {
			layout: "GRID",
			groupedList: true,
			//result: null,
			filterInput: "",
			spinning: false, // FP: 2026 ändras av mixin
			autoSearch: true,
			currentScrollFromTop: 0,
			currentScrollDirectionChangePosition: 0,
			currentScrollDirection: "DOWN",
			currentScrollY: 0,
			scrollUpStart: 0,
			scrollDownStart: 0,
			trackScrollingOn: "resultList",
			tableConfigKey: "searchProductList",
			showPageHeader: true,
			sortPopover: false,
			productGroupPopover: false,
			filterPopover: false,

			/*menuList: [{
				name: "menuSearch",
				visible: false
			}, {
				name: "menuMV",
				visible: false
			}],*/
			pageMenuList: [{
				name: "menuSearch",
				visible: false
			}, {
				name: "menuMV",
				visible: false
			}, {
				name: "menuCategory",
				visible: false
			}, {
				name: "menuManufactor",
				visible: false
			}],
			dropdown: {},

			//sort: { "property": "score", "name": "Relevans", "desc": false },

			sortList: [
				//{ property: "score", name: "Bästa träff", short: "Bästa",  desc: true },
				//{ property: "productId", name: "Nyaste först", short: "Nyaste", desc: true },
				STORE_SORT.SORT_DEFAULT,
				STORE_SORT.SORT_SEARCH,
				{ property: "name", name: "Produktnamn, A-Ö", short: "Namn", desc: false },
				{ property: "name", name: "Produktnamn, Ö-A", short: "Namn", desc: true },
				{ property: "artnr", name: "Artikelnummer, 0-Ö", short: "Artnr", desc: false },
				{ property: "artnr", name: "Artikelnummer, Ö-0", short: "Artnr", desc: true },
				{ property: "price2", name: "Pris, fallade", short: "Pris", desc: true },
				{ property: "price2", name: "Pris, stigande", short: "Pris", desc: false }],
			showDebugResult: false,
			popoverList: ["popoverMc", "popoverCategory", "popoverManufactor"],
			manufactorRefs: {}



		};
	},
	watch: {

		"pageMenuList": {
			handler() {
				this.hidePopovers('')
			}, deep: true
		},

		"searchProductConfig.manufactor": {
			handler(manufactor) {

				var query = this.$route.query;

				if (manufactor) {
					query = { ...query, m: manufactor.key }
				} else {
					query = { ...query, m: undefined }
				}

				this.routerReplaceQueryParameter(query)

			},
		},


		queryManufactor: function (manufactor) {
			console.log('FP: route queryManufactor: ', manufactor);

			if (!this.searchProductConfig.manufactor) {
				this.searchProductConfig.manufactor = manufactor
			}

		},

		"searchProductConfig.category": {
			handler(category) {

				var query = this.$route.query;

				if (category) {
					query = { ...query, c: category.key }
				} else {
					query = { ...query, c: undefined }
				}

				this.routerReplaceQueryParameter(query)

			},
		},

		queryCategory: function (category) {

			console.log('FP: route queryCategory: ', category);

			if (!this.searchProductConfig.category) {
				this.searchProductConfig.category = category
			}

		},

		"searchProductConfig.mc": {
			handler(mc) {


				console.log('FP: searchProductConfig.mc route ', mc);
				console.log('FP: searchProductConfig.mc route vad är brand?', this.searchProductConfig.brand?.name);

				var query = this.$route.query;

				if (mc) {
					query = { ...query, mc: mc.key }
				} else {
					query = { ...query, mc: undefined }
					query = { ...query, y: undefined }
				}

				var brand = this.searchProductConfig.brand; // FP: test

				if (brand) {
					query = { ...query, b: brand.key }
					console.log('FP: searchProductConfig.mc route mc: brand.key');
				} else {
					query = { ...query, b: undefined }
					query = { ...query, mc: undefined }
					query = { ...query, y: undefined }
					console.log('FP: searchProductConfig.mc route mc: undefined', brand);
				}




				if (!query) {
					query = {};
				}

				this.routerReplaceQueryParameter(query)



			},
		},

		queryBrandMc: function (brandMc) {
			console.log('FP: route queryBrandMc', brandMc);

			if (!this.searchProductConfig.brand) {
				this.searchProductConfig.brand = brandMc?.brand
			}

			if (!this.searchProductConfig.mc) {
				this.searchProductConfig.mc = brandMc?.mc
			}

		},

		"searchProductConfig.brand": { // anropas när man väljer brand 

			handler(brand) {

				console.log('FP: searchProductConfig.brand route ', brand);


				var query = this.$route.query;


				if (brand) {
					query = { ...query, b: brand.key }
					console.log('FP: searchProductConfig.brand route mc: brand.key');
				} else {
					query = { ...query, b: undefined }
					query = { ...query, mc: undefined }
					console.log('FP: searchProductConfig.brand route mc: undefined', brand);
				}

				if (!query) {
					query = {};
				}

				this.routerReplaceQueryParameter(query)



			},
		},


		queryBrand: function (brand) { // sätter brand från urlen. 
			console.log('FP: route queryBrand', brand);

			if (!this.searchProductConfig.brand) {
				this.searchProductConfig.brand = brand
			}



		},

		"searchProductConfig.year": { // när man har valt år 

			handler(year) {

				var yearDesc = null;

				if (year?.year) {
					yearDesc = year.year;
				}

				console.log('FP: searchProductConfig.year route ', yearDesc);

				console.log('FP: searchProductConfig.year route vad är brand?', this.searchProductConfig.brand?.name);
				console.log('FP: searchProductConfig.year route vad är mc?', this.searchProductConfig.mc?.key);

				var query = this.$route.query;


				if (year) {
					query = { ...query, y: yearDesc }
					console.log('FP: searchProductConfig.year route year: year');
				} else {
					query = { ...query, y: undefined }

					console.log('FP: searchProductConfig.year route year: undefined', yearDesc);
				}

				// FP: Test, samma som på modell 
				var brand = this.searchProductConfig.brand; // FP: test

				if (brand) {
					query = { ...query, b: brand.key }
					console.log('FP: searchProductConfig.mc route year: brand.key');

					var mc = this.searchProductConfig.mc; // FP: test

					if (mc) {
						query = { ...query, mc: mc.key }
						console.log('FP: searchProductConfig.mc route year: mc.key');
					} else {
						query = { ...query, mc: undefined }
						query = { ...query, y: undefined }
						console.log('FP: searchProductConfig.mc route year: undefined', brand);
					}


				} else {
					query = { ...query, b: undefined }
					query = { ...query, mc: undefined }
					query = { ...query, y: undefined }
					console.log('FP: searchProductConfig.mc route year: undefined', brand);
				}







				if (!query) {
					query = {};
				}

				this.routerReplaceQueryParameter(query)


			}

		},

		queryYear: function (year) { // när år sätts från urlen

			if (!this.searchProductConfig.year) {
				this.searchProductConfig.year = year
			}

		},



		/*
		filterInput: function (filter) {
			console.log("FP: watcher: ", filter);


			if (filter && filter.length > 2) {
				this.filterChanged(filter)
				this.showPageMenu('menuSearch');
			}

			if (filter == null || filter == "") {
				this.filterChanged(null)
			}
		}*/

		filterInput: function (newFilter, oldFilter) {

			console.log('FP: watch: filterInput: ');

			return this.filterInputChanged(newFilter, oldFilter)

		},

		"productGroup.key": {
			handler() {
				this.resetScrollLimit();
				this.resetScroll();
			}
		},

		"searchProductConfig.sort": {
			handler() {
				this.resetScrollLimit();
				this.resetScroll();
			}
		},
		

		/*
				"searchProductConfig.brand": {
					handler(brand) {
						console.log('FP: this.searchProductConfig.brand route ', brand?.name);
		
					},
				},
		
				"searchProductConfig.mc": {
					handler(mc) {
						console.log('FP: this.searchProductConfig.mc route ', mc?.key);
		
					},
				},
		
		
				"searchProductConfig.year": {
					handler(year) {
						console.log('FP: this.searchProductConfig.year route ', year);
		
					},
				},*/
	},
	computed: {

		title() {
			return "ProductsView, layout: " + this.layout;
		},

		outletList() {
			return this.outletProductIdList;
		},

		onlyInStock(){
			return this.searchProductConfig?.filter?.onlyInStock
		},

		queryManufactor() {

			if (this.$route?.query?.m) {
				return this.$store.getters[STORE_GETTER.MANUFACTOR_LIST]?.find(manufactor => manufactor.key == this.$route.query.m)
			}

			return null;

		},

		queryCategory() {
			if (this.$route?.query?.c) {

				const categoryTree = this.$store.getters[STORE_GETTER.CATEGORY_MODEL]?.categoryTree;

				if (categoryTree) {
					return categoryHelper.findInCategoryTree(this.$route.query.c, categoryTree);
				}
			}


			return null;
		},

		queryBrandMc() {

			if (!this.$route?.query?.mc) {
				return null;
			}

			const mcTree = this.$store.getters[STORE_GETTER.BASE_MODEL]?.mcTree;

			const mcKey = this.$route?.query?.mc;
			const brandId = parseInt(mcKey.split("-")[0]);

			if (mcTree) {

				const brand = mcTree.find(brand => brand.id == brandId);

				if (brand) {

					const mc = brand.modelList?.find(mc => mc.key == mcKey);

					return { brand: brand, mc: mc }

				}

			}

			return null;

		},

		queryBrand() {

			if (!this.$route?.query?.b || this.$route?.query?.mc) {
				return null;
			}

			const mcTree = this.$store.getters[STORE_GETTER.BASE_MODEL]?.mcTree;

			const brandKey = this.$route?.query?.b

			if (mcTree) {

				const brand = mcTree.find(brand => brand.key == brandKey);
				return brand;

			}

			return null;

		},

		queryYear() {

			if (!this.$route?.query?.y) {
				return null;
			}

			if (this.queryBrandMc?.mc?.yearList) {

				const year = this.queryBrandMc?.mc?.yearList?.find(year => year.year == this.$route?.query?.y)

				return year
			}

			return null
		},


		requestCount() {
			return this.$store.getters[STORE_GETTER.REQUEST_COUNT]
			//return this.$store.state.productStore.data.requestCount
		},




		baseManufactorListAllLength() {

			const manufactorList = this.$store.getters[STORE_GETTER.MANUFACTOR_LIST];

			if (manufactorList) {
				return manufactorList;
			}

			return 0;
		},

		baseManufactorList() {
			//const baseModel = this.$store.getters[STORE_GETTER.BASE_MODEL];

			const baseManufactorList = this.$store.getters[STORE_GETTER.MANUFACTOR_LIST];

			if (this.searchModel && this.searchModel.manufactorIdInResult && this.searchModel.manufactorIdInResult.length > 0) {

				var manufactorList = [];

				this.searchModel.manufactorIdInResult.forEach(manufactorId => {
					const manufactor = baseManufactorList?.find(manufactor => manufactor.manufactorId == manufactorId);
					if (manufactor) {
						manufactorList.push(manufactor);
					}


				})
				console.log('FP: baseManufactorList: ', manufactorList.length);

				//manufactorList.sort((a, b) => a.name > b.name);
				manufactorList = manufactorList.filter(manufactor => manufactor != null).sort((a, b) => (a.name + '').localeCompare(b.name)); // FP: fix för chrome

				return manufactorList;

			}

			return baseManufactorList;
		},



		baseManufactorListAll() {

			const manufactorList = this.$store.getters[STORE_GETTER.MANUFACTOR_LIST];

			if (manufactorList) {
				return manufactorList
			}

			return null;
		},

		baseCategoryModel() {

			return this.$store.getters[STORE_GETTER.CATEGORY_MODEL];
			/*
			const baseModel = this.$store.getters[STORE_GETTER.BASE_MODEL]

			if (baseModel && baseModel.categoryModel) {
				return baseModel.categoryModel
			}

			return null;*/
		},

		baseMcList() {

			const baseModel = this.$store.getters[STORE_GETTER.BASE_MODEL]

			if (baseModel && baseModel.mcList) {
				return baseModel.mcList
			}

			return null;

		},
		baseMcTree() {

			const baseModel = this.$store.getters[STORE_GETTER.BASE_MODEL]

			if (baseModel && baseModel.mcTree) {
				return baseModel.mcTree
			}

			return null;

		},

		productGroupKeyList() {

			const productType = this.$store.getters[STORE_GETTER.PRODUCT_TYPE_SELECTED];

			console.log('FP: productType: ', productType);



			var list = this.productGroupList?.filter(productGroup => {
				if (!productType || !productGroup.pt) {
					return true;
				}

				return productGroup.pt == productType.pt
			});

			return list;


		},


		showSelectMc() {

			return this.$store.getters[STORE_GETTER.PRODUCT_TYPE_SELECTED_MC];

		},

		searchProductTextfieldSpinning(){
			//const rebuildingSearchModel = this.$store.getters[STORE_GETTER.REBUILDING_SEARCH_MODEL];
			return this.spinning //|| rebuildingSearchModel
		},

		showRebuildSearchIndex(){
			const rebuildingSearchModel = this.$store.getters[STORE_GETTER.REBUILDING_SEARCH_MODEL];
			return rebuildingSearchModel;
		},

		showLoadingProducts(){

			return false;
			// hämta antalet produkter i listan
			//const productListCount = parseInt(this.$store.getters[PRODUCT_STORE_GETTER.PRODUCT_LIST]?.length)
			//const rebuildingSearchModel = this.$store.getters[STORE_GETTER.REBUILDING_SEARCH_MODEL];
			//const requestCount = this.$store.getters[STORE_GETTER.REQUEST_COUNT];

			//return (productListCount == 0 && requestCount > 0) || rebuildingSearchModel
		}



		/*productGroupKeyList: [
			{ key: null, label: "Alla produkter" },
			{ key: "VIEWED", label: "Nyligen visade" },

		]*/

		/*productGroupList(){
			const productGroupList = this.$store.getters[PRODUCT_STORE_GETTER.PRODUCT_GROUP_LIST];

			return productGroupList;

		},*/

		/*productGroup(){
			const key =  this.searchProductConfig?.productGroupKey

			const productGroup = this.productGroupList?.find(productGroup => productGroup.key == key)

			return productGroup
		},*/

		/*productList5(){ // FP: Döp om denna 

			if (!this.productGroup  || this.productGroup.key == null){
				return this.model.productList;
			}

			var productList = [];

			const productIdList = this.productGroup.productIdList

			console.log('FP: productList5: ', productList);

			productIdList?.forEach(productId => {

					if (productId !== null) {

						const product = this.$store.state.productStore.data.productList[productId];
						productList.push(product);
					}
				});

			console.log('FP: productList5: ', productList);

			if (this.searchProductConfig && this.searchProductConfig.sort) {
				productList = listHelper.sortList(productList, this.searchProductConfig.sort.property, this.searchProductConfig.sort.desc);
			}


			//productList = listHelper.trimToLimit(productList, this.tableConfig.scrollLimit);
				
				return productList;


		}*/


	},
	methods: {

		setupUrl() { // om searchModelConfig skiljer så uppdatera urlen så att den stämmer

			console.log('FP: this.searchProductConfig', this.searchProductConfig);

			const brandKey = this.searchProductConfig?.brand?.key
			const mcKey = this.searchProductConfig?.mc?.key


			const name = this.$route.name;

			var query = {}

			if (brandKey) {
				query.b = brandKey
			}

			if (mcKey) {
				query.mc = mcKey
			}


			this.$router.replace({ name: name, query: query })


		},
		showSideMenuCategory() {
			this.$store.commit(STORE_COMMIT.SET_SIDE_MENU_KEY, "category")
			this.$emit('sideMenuVisible', true)
		},
		showProductDetails(product) {
			//this.$router.push('/product/' + product.productId + "/" + product.urlKey)
			this.routerShowProductDetails(product);

		},

		isSortSelected(sort) {
			return this.searchProductConfig?.sort?.property == sort.property && this.searchProductConfig?.sort?.desc == sort.desc
		},

		isProductGroupSelected(productGroup) {
			return this.searchProductConfig?.productGroupKey == productGroup.key
		},
		yearSelectedMV() {
			if (this.searchProductConfig.brand == null) {
				//alert("brand");
				return;
			}

			if (this.searchProductConfig.mc == null) {
				alert("mc");
				return;
			}


			this.hideAllPageMenu()

		},


		updateUrlQuery() {

			/*const searchProductConfig = this.searchProductConfig;

			const name = this.$route.name;
			var query = this.$route.query;

			// manufactor 
			if (searchProductConfig.manufactor){
				query = { ...query, m: searchProductConfig.manufactor.key}
			}else{
				delete query.m
			}

			this.$router.replace({ name: name, query: query })*/
		},


		setupScroll() {
			// FP: TODO fixa denna 
		},



		selectPopoverOpen(popoverName) {
			//alert("selectPopover: " + popoverName);
			this.hidePopovers(popoverName);

		},

		productGroupLabel(productGroup) {
			


			/*if (this.searchProductConfig?.filter?.onlyInStock &&  productGroup?.labelOnlyInStock) {
				return productGroup?.labelOnlyInStock
			}*/

			return productGroup?.label;

		},


		productGroupLabelMobile(productGroup) {
			const label = productGroup?.label;

			if (!label) {
				return "??";
			}

			/*if (this.searchProductConfig?.filter?.onlyInStock && productGroup?.shortOnlyInStock){
				return productGroup?.shortOnlyInStock
			}*/

			if (productGroup?.short ) {
				return productGroup.short
			}

			const maxLength = 10;

			if (label.length > maxLength){
				return label.slice(0, maxLength - 1) + "...";
			}

			return productGroup?.label;

		},

		productGroupIconDropdown(productGroup){
			return this.productGroupIcon(productGroup, true, 'grey')
		},

		productGroupIconLabel(productGroup){
			return this.productGroupIcon(productGroup, false, 'white');
		},


		productGroupIcon(productGroup, dropdown, color) {

			if (productGroup && productGroup.key == null && productGroup.icon == null && !productGroup.outlet) {
				if (dropdown){
					return { fileName: "check_circle_grey", padding: "10%" };
				}else{
					return { fileName: "circle_in_stock_green", padding: "10%" };
				}
				
			}


			if (productGroup && productGroup.outlet) {
				if (dropdown) {
					return { fileName: "outlet_" + color, padding: "10%" };
				} else {

					return { fileName: "percent_" + color, padding: "25%" };
				}

			}

			if (productGroup && productGroup.icon == 'viewed') {
				return {
					fileName: "viewed_" + color
				};
			}

			if (productGroup && productGroup.icon == 'favorite') {
				return {
					fileName: "bookmark_square_" + color
				};
			}

			if (productGroup && productGroup.key != null) {
				return {
					fileName: "subset_" + color
				};
			}



			return false;
		},

		productGroupChanged(productGroup){

			if (this.searchProductConfig.productGroupKey != productGroup.key){
				this.resetSearchProductConfig(productGroup.key)
			}

			

			
			this.searchProductConfig.productGroupKey = productGroup.key; 
			this.productGroupPopover = false; 
			this.resetScrollLimit();

			//alert("productGroupChanged");
			
		},



		hidePopovers(skipPopoverName) {

			//alert("Skip: " + skipPopoverName);

			this.popoverList.forEach(popoverName => {

				if (this.$refs[popoverName]) {
					console.log('FP: refs: popover: ', this.$refs[popoverName]);
					if (skipPopoverName != popoverName) {
						this.$refs[popoverName].closePopover();
						//alert("close: " + popoverName)
					}


				}

			});

			/*
			if (this.$refs){


				this.$refs.forEach(ref =>{

					console.log('FP: ref: : ', ref);
					

				});*/



			/*
			this.$refs.selectMc.popoverMc = false
			this.$refs.selectCategory.popoverCategory = false
			this.$refs.selectManufactor.popoverManufactor = false*/

		},

		testXX() {
			this.$store.dispatch({ type: PRODUCT_STORE_ACTION.TEST_GET_PRODUCT_LIST, data: {} });
		},

		headerClicked(property) {
			const tableConfig = this.tableConfig
			tableConfig.sort = property
			tableConfig.desc = !tableConfig.desc
			tableConfig.scrollLimit = tableConfig.defaultScrollLimit

			this.$store.commit(STORE_COMMIT.UPDATE_TABLE_CONFIG, tableConfig);
			this.resetScroll();

		},



		resetScroll() { // FP: Körs när man väljer produkt-type
			//alert("resetscroll");
			this.currentScrollFromTop = 0
			document.body.scrollTop = 0;
			document.documentElement.scrollTop = 0;
			document.scrollingElement.scrollTop = 0;
			window.scrollTop = 0;
		},

		resetScrollLimit() {
			const tableConfig = this.tableConfig
			tableConfig.scrollLimit = tableConfig.defaultScrollLimit
			this.$store.commit(STORE_COMMIT.UPDATE_TABLE_CONFIG, tableConfig);
			if (this.debug){
				//alert("Debug: reset");
			}
			
		},

		trackScrolling() {

			const element = document.getElementById(this.trackScrollingOn);
			const scrollFromTop = element.scrollTop + element.clientHeight + 100
			const value = element.scrollHeight < scrollFromTop;

			//console.log('FP: element.scrollHeight:', element.scrollHeight);
			//console.log('FP: element.scrollTop + element.clientHeight + 100:', element.scrollTop + element.clientHeight + 100);



			if (value && scrollFromTop > this.currentScrollFromTop) {
				this.currentScrollFromTop = scrollFromTop
				const tableConfig = this.tableConfig
				tableConfig.scrollLimit += tableConfig.append
				this.$store.commit(STORE_COMMIT.UPDATE_TABLE_CONFIG, tableConfig);
			}
		},
		trackScrollingDocument() {

			//console.log('FP: trackScrollingDocument');
			
			var totalPageHeight = document.body.scrollHeight;
			//var totalPageHeight = window.scrollHeight;

			var scrollFromTop = window.scrollY + window.innerHeight + 100;


			var value = totalPageHeight - (scrollFromTop);

			//console.log('FP: window.scrollY: ', window.scrollY);


			if (window.scrollY > this.currentScrollY) {

				if (this.currentScrollDirection == "UP") {
					this.currentScrollDirectionChangePosition = window.scrollY

				}

				this.currentScrollDirection = "DOWN";
			}

			if (window.scrollY < this.currentScrollY) {

				if (this.currentScrollDirection == "DOWN") {
					this.currentScrollDirectionChangePosition = window.scrollY
				}

				this.currentScrollDirection = "UP";
			}

			if (this.currentScrollDirection == "DOWN" && window.scrollY > this.currentScrollDirectionChangePosition + 1500) {
				this.showPageHeader = false
			}

			if (this.currentScrollDirection == "UP" && window.scrollY < this.currentScrollDirectionChangePosition - 50) { // screenY
				this.showPageHeader = true;
			}


			//console.log('FP: currentScrollDirection: ' + this.currentScrollDirection + ", changePos: ", this.currentScrollDirectionChangePosition);

			this.currentScrollY = scrollY

			if (value < 0 && scrollFromTop > this.currentScrollFromTop) {


				this.currentScrollFromTop = scrollFromTop
				const tableConfig = this.tableConfig
				tableConfig.scrollLimit += tableConfig.append
				this.$store.commit(STORE_COMMIT.UPDATE_TABLE_CONFIG, tableConfig);
			}



		},

		filterPressed(){
			this.$emit("sideMenuVisible", true);
		},

		


		
		getProductRowListComplete() {
			this.triggerSearch();
		},

		scrollToManufactorId(manufactorId) {
			const el = this.manufactorRefs[manufactorId];

			if (el) {
				el.scrollIntoView({
					behavior: 'smooth',
					block: 'start'
				});
			}
		},

		toggleOnlyInStock(){

			if (this.searchProductConfig?.filter?.onlyInStock){
				this.searchProductConfig.filter.onlyInStock = false;
			}else{
				this.searchProductConfig.filter.onlyInStock = true;
			}
		},

		showAllProductList(){
			this.searchProductConfig.productGroupKey = null; 
			this.searchProductConfig.filter.onlyInStock = false;
			this.resetScrollLimit()
			this.resetScroll();
			this.enterPressed();
		},

		searchProductTextfieldClicked(){
	alert("SearchProductTextfield")
		}



		/*getScroller() {
			if (document.body.scrollTop > 0) return document.body;
			if (document.documentElement.scrollTop > 0) return document.documentElement;
			return document.scrollingElement || document.documentElement;
		},*/


		/*trackScrollingDocumentNEW() { // FP: Kolla upp om denna körs?

			//console.log('FP: scroll: ', document.body.scrollTop);
			
		
			var totalPageHeight = this.getScroller().scrollHeight;
			var scrollTop = this.getScroller().scrollTop;

			var scrollFromTop = scrollTop + window.innerHeight + 100;


			var value = totalPageHeight - (scrollFromTop);

			//console.log('FP: SC, totalPageHeight: ', totalPageHeight);
			//console.log('FP: SC, scrollTop: ', scrollTop);
			//console.log('FP: SC, scrollFromTop: ', scrollFromTop);


			if (scrollTop > this.currentScrollY) {

				if (this.currentScrollDirection == "UP") {
					this.currentScrollDirectionChangePosition = scrollTop

				}

				this.currentScrollDirection = "DOWN";
			}

			if (scrollTop < this.currentScrollY) {

				if (this.currentScrollDirection == "DOWN") {
					this.currentScrollDirectionChangePosition = scrollTop
				}

				this.currentScrollDirection = "UP";
			}

			if (this.currentScrollDirection == "DOWN" && scrollTop > this.currentScrollDirectionChangePosition + 1500) {
				this.showPageHeader = false
			}

			if (this.currentScrollDirection == "UP" && scrollTop < this.currentScrollDirectionChangePosition - 50) { // window.screenY
				this.showPageHeader = true;
			}


			//console.log('FP: currentScrollDirection: ' + this.currentScrollDirection + ", changePos: ", this.currentScrollDirectionChangePosition);

			this.currentScrollY = scrollTop

			if (value < 0 && scrollFromTop > this.currentScrollFromTop) {
				this.currentScrollFromTop = scrollFromTop
				const tableConfig = this.tableConfig
				tableConfig.scrollLimit += tableConfig.append
				this.$store.commit(STORE_COMMIT.UPDATE_TABLE_CONFIG, tableConfig);
			}



		},*/

	},



	created() {
		//document.getElementById(this.trackScrollingOn).addEventListener("scroll", this.trackScrolling);

		this.routerSetupProductsUrl()

		// FP: SC document.addEventListener("scroll", this.trackScrollingDocument);

		document.addEventListener("scroll", this.trackScrollingDocument, { passive: false })
		//document.body.addEventListener("scroll", this.trackScrollingDocumentNEW, { passive: false })

		if (this.tableConfig && this.tableConfig.filter) {
			this.filterInput = this.tableConfig.filter
		}

	

		if (this.$store.getters[PRODUCT_STORE_GETTER.PRODUCT_LIST]?.length < 100) {
			this.getProductRowList();
		}

		// om det gått mer än x minuter så hämta om data.
		console.log('FP: PRODUCT_LIST_COMPLETE_DATE: ', this.$store.getters[PRODUCT_STORE_GETTER.PRODUCT_LIST_COMPLETE_DATE]);
		

		// om produktlistan ska laddas om
		const productListCompleteDate = this.$store.getters[PRODUCT_STORE_GETTER.PRODUCT_LIST_COMPLETE_DATE];

		if (productListCompleteDate && (Math.floor((Date.now() - productListCompleteDate) / 1000) > settings.productListMaxAge) ){
			
			this.getProductRowList();
		}

		// om basemodel ska laddas om
		const baseModelCompleteDate = this.$store.getters[STORE_GETTER.BASE_MODEL_COMPLETE_DATE]

		console.log('FP: BASE_MODEL_COMPLETE_DATE: ', Math.floor((Date.now() - baseModelCompleteDate) / 1000));

		

		if (baseModelCompleteDate && (Math.floor((Date.now() - baseModelCompleteDate) / 1000) > settings.baseModelMaxAge)) {
			this.getSearchIndexModel();
			this.getBaseModel();

		} else if (!baseModelCompleteDate){
			this.getBaseModel();
			
		}


		/*if (this.$store.getters[PRODUCT_STORE_GETTER.PRODUCT_LIST_AGE] > settings.productListMaxAge){
			alert("Ladda om")
		} */


		this.enterPressed()

		console.log('FP: router created()');

		if (this.debug){
			this.sortList.push(STORE_SORT.SORT_SEARCH_WORST);
		}



	},
	

	unmounted() {
		//const element = document.getElementById(this.trackScrollingOn);

		//if (element) {
		//element.removeEventListener("scroll", this.trackScrolling);

		//}

		// FP: SC document.removeEventListener("scroll", this.trackScrollingDocument);
		document.removeEventListener("scroll", this.trackScrollingDocument)
		//document.body.removeEventListener("scroll", this.trackScrollingDocumentNEW)
	},


};
</script>



<style scoped>
html body div#app div div div div.content div.page div.page-header div.page-header-menu-hide,
html body div#app div div div div.content div.page div.page-header div.page-header-menu-show {
	/*background: red; override för ipad längre ned */
	height: 150px;
	/* 120 */
	/* 160 */
	/* 210 */
	/* FP: styr höjden på top menyn med filter (välj mc, kategori ...)*/
}

html body div#app div.site.logout div.content div.page div.page-header div.page-menu {
	top: calc(var(--top-header-height-logout) + 150px);
	/* 120 */
	/* har ett lägre värde för att dölja kategori */
	/* override nedan för iphone */
	z-index: 20;
}

html body div#app div.site.login div div.content div.page div.page-header div.page-menu {
	top: calc(var(--top-header-height-login) + 150px);
	/* 120 */
	/* har ett lägre värde för att dölja kategori */
	z-index: 20;
}

/* FP: justerar ned från toppen så de ligger över sökfältet */
html body div#app div.site.logout div.content div.page div.page-header div.page-menu.page-menu-menu-mv,
html body div#app div.site.logout div.content div.page div.page-header div.page-menu.page-menu-menu-category,
html body div#app div.site.logout div.content div.page div.page-header div.page-menu.page-menu-menu-manufactor {
	top: calc(var(--top-header-height-logout) + 35px);
	z-index: 40;

}

/* FP: justerar ned från toppen så de ligger över sökfältet */
html body div#app div.site.login div.content div.page div.page-header div.page-menu.page-menu-menu-mv,
html body div#app div.site.login div.content div.page div.page-header div.page-menu.page-menu-menu-category,
html body div#app div.site.login div.content div.page div.page-header div.page-menu.page-menu-menu-manufactor {
	top: calc(var(--top-header-height-login) + 35px);
	z-index: 40;

}

html body div#app div.site.logout div div div.content.logout div.page div.page-header div.filter-boxes{
	height:60px; /* override för iphone längre ned */
}

div#filter-wrapper {
	flex-direction: row;
}

@media (max-width: 950px) {

	div#filter-wrapper {
		flex-direction: column;
	}

	html body div#app div div div div.content div.page div.page-header div.page-header-menu-hide,
	html body div#app div div div div.content div.page div.page-header div.page-header-menu-show {
		/* sätts längre upp  */
		height: 250px;

	}

		html body div#app div.site.logout div div div.content.logout div.page div.page-header div.filter-boxes {
			height: 120px;
			width:100%;
		}

				html body div#app div.site.logout div.content div.page div.page-header div.page-menu {
					top: calc(var(--top-header-height-logout) + 200px);
					/* sätts längre upp */
				}
}

html body div#app div.site.logout div.page div.page-header.show {
	top: var(--top-header-height-logout);
	transition: top 0.5s;

}

html body div#app div.site.login div.page div.page-header.show {
	top: var(--top-header-height-login);
	transition: top 0.5s;

}

html body div#app div.site div.page div.page-header.hide {
	transition: top 1.0s;
	top: -500px;

}

div.productGrid{
	display: grid;
	gap: 10px;
	grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
	grid-template-rows: repeat(minmax(200px, 300px));
}



@media (max-width: 620px) {
	/*div#productGrid {
		grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));

		
	}*/

		div.productGrid {
			grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
	
		}

}

@media (max-width: 768px) {
.filter-wrapper {
		--filter-wrapper-font-normal: 0.85rem;
		--filter-wrapper-font-small: 0.75rem;
	}

	.filter-boxes{
		flex-direction: column;
	}
	
}

div#dropdown-sort-button{
	width:185px;
	background: var(--grey-1);
	padding: 5px;
	border: 1px solid var(--grey-4);
	border-radius: 5px;
}

div#dropdown-product-key-button {
	width: 185px;
		background: var(--grey-1);
		padding: 5px;
		border: 1px solid var(--grey-4);
		border-radius: 5px;
}

div#filter-button-desktop {
	/*width: 180px;*/
	background: var(--grey-1);
	padding: 5px;
	border: 1px solid var(--grey-4);
	border-radius: 5px;
}

div#filter-button-mobile {
	width: 80px;
	background: var(--grey-1);
	padding: 5px;
	border: 1px solid var(--grey-4);
	border-radius: 5px;
}

div#dropdown-product-key, div#dropdown-sort, div#filter-button-desktop{
	flex-grow: unset;
}


@media (max-width: 768px) {
	div#dropdown-sort-button{
		flex-grow:1;
		width: unset;
	}
div#dropdown-product-key-button {
	flex-grow: 1;
	width: unset;
}
div#filter-button {
	flex-grow: 1;
}

div#filter-button-desktop {
	max-width:80px;
}

div#dropdown-product-key{
	width: unset;
	flex-grow:1;
}

div#dropdown-sort {
	width: unset;
	flex-grow:1;
}

}

div#product-group-type-footer-button{
padding: 3px;
	padding-left: 5px;
	padding-right: 5px;
}

div#product-group-type-footer {
	flex-direction: row;
}

div#dropdownGroupWrapper div#dropdownGroup{
justify-content: end;
}

div#dropdownGroupWrapper div#dropdownGroup {
	justify-content: end;
}

@media (max-width: 768px) {

	div#product-group-type-footer-button {
		padding: 10px;
		margin-top:10px;
		
	}

	div#product-group-type-footer {
		flex-direction: column;
	}

		div#dropdownGroupWrapper {
			width: calc(100% - 0px);
		}

		div#dropdownGroupWrapper div#dropdownGroup.flexcenter {
			justify-content: space-between;
		}

}
div#manufactorGrid{
	margin-bottom: 10px;
	
}

div#manufactorGrid::-webkit-scrollbar-thumb {
	background: transparent;


}
div#manufactorGrid:hover::-webkit-scrollbar-thumb {
	background: rgba(0, 0, 0, 0.3);
}

div#manufactorGrid div {
	display: flex;
	padding-left: 30px;
	padding-right: 30px;
	flex: 0 0 auto;
	height: 100%;
	background: var(--grey-3);
	color: black;
	border-radius: 5px;
}


div#filterList div.filter {
	flex-wrap: nowrap;
}

div#filterList div.filter{
	background:var(--bg-message); 
	flex-direction: row;
	padding:3px;
	padding-left:5px;
	padding-right:5px;
	border-radius: 5px;
	color:white;
}

#filterList::-webkit-scrollbar {
	height: 2px;
}

#filterList::-webkit-scrollbar-thumb {
	background: rgba(0, 0, 0, 0.3);
	border-radius: 999px;
}

#filterList::-webkit-scrollbar-track {
	background: transparent;
}
</style>
